(function () {
  // --------------Performance Optimization Script-----------------

  document.addEventListener("DOMContentLoaded", () => {

        // 1. Lazy-load all images that don't have loading="lazy"
        document.querySelectorAll('img:not([loading])').forEach(img => {
            img.loading = "lazy";
        });

        // 2. Defer heavy scripts by loading them after first interaction
        const deferScripts = () => {
            document.querySelectorAll('script[data-defer="true"]').forEach(tag => {
            const s = document.createElement('script');
            s.src = tag.getAttribute("data-src");
            s.async = true;
            document.body.appendChild(s);
            });
            window.removeEventListener("scroll", deferScripts);
            window.removeEventListener("mousemove", deferScripts);
            window.removeEventListener("touchstart", deferScripts);
        };

        window.addEventListener("scroll", deferScripts);
        window.addEventListener("mousemove", deferScripts);
        window.addEventListener("touchstart", deferScripts);

        // 3. Reduce forced reflows (expensive operations)
        let resizeTimeout;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
            document.body.classList.add("resize-done");
            }, 200);
        });

        // 4. Preload above-the-fold images
        document.querySelectorAll("img.hero, img.banner, img.featured").forEach(img => {
            img.loading = "eager";
            img.fetchPriority = "high";
        });

        // 5. Clean unused classes that cause layout thrashing
        document.querySelectorAll("[data-temp]").forEach(el => el.removeAttribute("data-temp"));
  });
  // ------------ Meta Slider Script------------------
  document.addEventListener("DOMContentLoaded", function () {
      const metaSliderContent = document.querySelectorAll('[js-meta-slider-]');
      const textWithImageContent = document.querySelector('[js-text-with-image-content]');
      //------------ Meta Slider Code ------------
      if (metaSliderContent) {
          new Swiper("[js-meta-slider]", {
              slidesPerView: 1.8,
              spaceBetween: 8,
              watchSlidesProgress: true,
              draggable: true,
              autoHeight: false,
              watchOverflow: true,
              threshold: 10,
              mousewheel: {
                  forceToAxis: true
              },
              breakpoints: {
                  0: {
                      slidesPerView: 1.673,
                      spaceBetween: 8,
                  },
                  720: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                  },
                  960: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                  },
                  1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                  },
              },
          });
          const accordionHeaders = document.querySelectorAll('[js-accordion-header]');

          accordionHeaders.forEach(header => {
              header.addEventListener('click', function () {
                  const accordion = header.closest('.meta-slider__accordion');
                  accordion.classList.toggle('active');
              });
          });
      }
      //----------------text with image slider-----------------
      if (textWithImageContent) {
          if (window.innerWidth < 720) {
              const slider = new Swiper("[js-text-with-image-slider]", {
                  loop: false,
                  slidesPerView: 1,
                  spaceBetween: 20,
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
                  breakpoints: {
                      768: { slidesPerView: 3, spaceBetween: 10 },
                      1279: { slidesPerView: 3, spaceBetween: 20 }
                  }
              });

              function handleBulletClick(index) {
                  slider.slideTo(index);
              }

              function updateBullets() {
                  const bulletContainers = document.querySelectorAll('.text-with-image__static--pagination');
                  bulletContainers.forEach(container => {
                      const bullets = container.querySelectorAll('.text-with-image__bullet');
                      bullets.forEach((bullet, index) => {
                          bullet.classList.toggle('active', index === slider.activeIndex);
                          bullet.removeEventListener('click', bullet.clickHandler);
                          bullet.clickHandler = () => handleBulletClick(index);
                          bullet.addEventListener('click', bullet.clickHandler);
                      });
                  });
              }

              updateBullets();
              slider.on('slideChange', updateBullets);
              const observer = new MutationObserver(updateBullets);
              document.querySelectorAll('.text-with-image__static--pagination').forEach(container => {
                  observer.observe(container, { childList: true, subtree: true });
              });
          }
      }
      //-----------------accordion -----------------
      const accordionContent = document.querySelectorAll('[js-product-accordion]');
      if (accordionContent) {
          const accordions = document.querySelectorAll(".product-accordion__flex-box");
          accordions.forEach(flexBox => {
              flexBox.addEventListener("click", function () {
                  const currentItem = this.closest(".product-accordion__item");
                  const isActive = currentItem.classList.contains("active");
                  document.querySelectorAll(".product-accordion__item").forEach(item => {
                      item.classList.remove("active");
                  });
                  if (!isActive) {
                      currentItem.classList.add("active");
                  }
              });
          });
      }
      const accordionSections = document.querySelectorAll('[js-accordion-parent]');
      if (accordionSections.length) {
          accordionSections.forEach(section => {
              const items = section.querySelectorAll('[js-accordian-item]');
              const triggers = section.querySelectorAll('[js-accordion-title]');

              triggers.forEach(trigger => {
                  trigger.addEventListener('click', function () {
                      const currentItem = this.closest('[js-accordian-item]');
                      const isActive = currentItem.classList.contains('active');

                      items.forEach(item => item.classList.remove('active'));

                      if (!isActive) {
                          currentItem.classList.add('active');
                      }
                  });
              });
          });
      }

      // collection slider
      const collection = document.querySelector('.custom-collection');
      if (collection) {
          document.querySelectorAll('[data-js-product-image-slider]').forEach((sliderEl) => {
              new Swiper(sliderEl, {
                  loop: false,
                  slidesPerView: 1,
                  spaceBetween: 10,
                  pagination: {
                      el: sliderEl.querySelector('.swiper-pagination'),
                      clickable: true,
                  },
              });
          });
      }

  });

  const menuDrawer = document.querySelector('.menu-drawer');
  if (menuDrawer) {
      const observer = new MutationObserver(() => {
          const isVisible = menuDrawer.classList.contains('is-open') || menuDrawer.classList.contains('active') || menuDrawer.hasAttribute('open');
          if (isVisible) {
              document.body.classList.add('drawer--open');
          } else {
              document.body.classList.remove('drawer--open');
          }
      });

      observer.observe(menuDrawer, { attributes: true, attributeFilter: ['class', 'open', 'active'] });
  }

  document.addEventListener("DOMContentLoaded", function () {
      if (!document.querySelector('.banner-theme-level')) {
          document.body.classList.add('banner-theme-level-body');
      }
  });

  // ------------Review and Review Gallery Script------------------
  document.addEventListener("DOMContentLoaded", () => {
      const reviewSections = document.querySelectorAll("[js-reviews-section]");

      reviewSections.forEach((reviewSection) => {
          const tabItems = reviewSection.querySelectorAll("[js-tab-item]");
          const cardItems = reviewSection.querySelectorAll("[js-card-item]");
          const popupClick = reviewSection.querySelectorAll("[js-reviews-popup-click]");
          const popupContent = reviewSection.querySelectorAll("[js-reviews-popup-item]");
          const removeIcon = reviewSection.querySelectorAll("[js-reviews-popup-remove]");
          const popupOverlay = reviewSection.querySelectorAll("[js-reviews-popup-overlay]");
          const sliderEl = reviewSection.querySelector("[js-reviews-slider]");
          const nextBtn = reviewSection.querySelector("[js-reviews-slider-next-btn]");
          const prevBtn = reviewSection.querySelector("[js-reviews-slider-prev-btn]");
          let swiper = null;

          function initSwiper() {
              if (swiper) swiper.destroy(true, true);
              if (!sliderEl) return;
              swiper = new Swiper(sliderEl, {
                  slidesPerView: 1.375,
                  spaceBetween: 12,
                  watchSlidesProgress: true,
                  draggable: true,
                  autoHeight: false,
                  watchOverflow: true,
                  threshold: 10,
                  mousewheel: { forceToAxis: true },
                  navigation: {
                      nextEl: nextBtn,
                      prevEl: prevBtn,
                  },
                  breakpoints: {
                      520: { slidesPerView: 2, spaceBetween: 12 },
                      720: { slidesPerView: "auto", spaceBetween: 14 },
                      1024: { slidesPerView: "auto", spaceBetween: 20 },
                  },
              });
          }
          function updateCards() {
              const activeTags = [];
              tabItems.forEach(tab => {
                  if (tab.classList.contains('active') && tab.dataset.tag !== 'alle') {
                      activeTags.push(tab.dataset.tag);
                  }
              });

              const alleActive = Array.from(tabItems).some(
                  tab => tab.dataset.tag === 'alle' && tab.classList.contains('active')
              );

              cardItems.forEach(card => {
                  const cardTag = card.dataset.cardTag?.toLowerCase().replace(/\s+/g, '-'); // handleize
                  if (alleActive) {
                      card.classList.add("active");
                  } else {
                      const show = activeTags.includes(cardTag);
                      card.classList.toggle("active", show);
                  }
              });
          }

          tabItems.forEach(tab => {
              tab.addEventListener("click", function () {
                  const tag = this.dataset.tag;
                  const alleTabs = reviewSection.querySelectorAll('[data-tag="alle"]');

                  if (tag === 'alle') {
                      tabItems.forEach(t => {
                          if (t.dataset.tag !== 'alle') {
                              t.classList.remove("active");
                          }
                      });
                      alleTabs.forEach(t => t.classList.add("active"));
                  } else {
                      alleTabs.forEach(t => t.classList.remove("active"));

                      const isActive = this.classList.contains('active');

                      const sameTagTabs = reviewSection.querySelectorAll(`[data-tag="${tag}"]`);
                      sameTagTabs.forEach(t => {
                          t.classList.toggle("active", !isActive);
                      });
                  }

                  updateCards();
                  initSwiper();
              });
          });

          popupClick.forEach((el, index) => {
              el.addEventListener("click", () => {
                  popupContent.forEach((content, i) => {
                      if (i !== index) content.classList.remove("is-open");
                  });
                  popupContent[index].classList.add("is-open");
              });
          });

          removeIcon.forEach(icon => {
              icon.addEventListener("click", function () {
                  this.closest("[js-reviews-popup-item]").classList.remove("is-open");
              });
          });

          popupOverlay.forEach(overlay => {
              overlay.addEventListener("click", function () {
                  this.closest("[js-reviews-popup-item]").classList.remove("is-open");
              });
          });

          const alleTabs = reviewSection.querySelectorAll('[data-tag="alle"]');
          alleTabs.forEach(tab => tab.classList.add("active"));

          updateCards();
          initSwiper();

          function formatRelativeGermanDate(dateString) {
              const inputDate = new Date(dateString);
              const today = new Date();
              inputDate.setHours(0, 0, 0, 0);
              today.setHours(0, 0, 0, 0);

              const msPerDay = 24 * 60 * 60 * 1000;
              const diffDays = Math.floor((today - inputDate) / msPerDay);

              if (isNaN(diffDays)) return dateString;

              if (diffDays === 0) {
                  return inputDate.toLocaleDateString("de-DE", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                  });
              } else if (diffDays === 1) {
                  return 'Vor 1 Tag';
              } else if (diffDays < 7) {
                  return `Vor ${diffDays} Tagen`;
              } else if (diffDays < 30) {
                  const weeks = Math.floor(diffDays / 7);
                  return `Vor ${weeks} Woche${weeks > 1 ? 'n' : ''}`;
              } else if (diffDays < 365) {
                  const months = Math.floor(diffDays / 30);
                  return `Vor ${months} Monat${months > 1 ? 'en' : ''}`;
              } else {
                  const years = Math.floor(diffDays / 365);
                  return `Vor ${years} Jahr${years > 1 ? 'en' : ''}`;
              }
          }

          reviewSection.querySelectorAll('.reviews-section__date').forEach(el => {
              const dateStr = el.getAttribute('data-date');
              if (dateStr) {
                  el.textContent = formatRelativeGermanDate(dateStr.trim());
              }
          });
      });
  });
  document.addEventListener('DOMContentLoaded', function () {
      const reviewGalleries = document.querySelectorAll('[js-review-gallery]');
      reviewGalleries.forEach(function (gallery) {
          gallery.addEventListener('click', function (event) {
              const openBtn = event.target.closest('[js-review-open]');
              const closeBtn = event.target.closest('[js-review-close]');
              const overlay = event.target.closest('[js-review-overlay]');
              const modals = Array.from(gallery.querySelectorAll('[js-review-modal]'));

              if (openBtn) {
                  event.preventDefault();
                  const openBtns = Array.from(gallery.querySelectorAll('[js-review-open]'));
                  const index = openBtns.indexOf(openBtn);
                  modals.forEach(function (modal) {
                      modal.classList.remove('is-open');
                  });
                  if (index > -1 && modals[index]) {
                      modals[index].classList.add('is-open');
                  }
                  return;
              }

              if (closeBtn) {
                  event.preventDefault();
                  const closeBtns = Array.from(gallery.querySelectorAll('[js-review-close]'));
                  const index = closeBtns.indexOf(closeBtn);
                  if (index > -1 && modals[index]) {
                      modals[index].classList.remove('is-open');
                  }
                  return;
              }

              if (overlay) {
                  const overlays = Array.from(gallery.querySelectorAll('[js-review-overlay]'));
                  const index = overlays.indexOf(overlay);
                  if (index > -1 && modals[index]) {
                      modals[index].classList.remove('is-open');
                  }
                  return;
              }
          });
          reviewGalleries.forEach(gallery => {
              const cards = Array.from(gallery.querySelectorAll('.reviews-section__card'));
              const loadMoreBtn = gallery.querySelector('[js-load-more-btn]');
              const itemsPerPage = 6;
              cards.forEach((card, i) => {
                  if (i < itemsPerPage) {
                      card.classList.add('active');
                      card.classList.remove('hidden');
                  } else {
                      card.classList.add('hidden');
                      card.classList.remove('active');
                  }
              });
              if (cards.length <= itemsPerPage) {
                  loadMoreBtn.style.display = 'none';
              }

              loadMoreBtn.addEventListener('click', () => {
                  const visibleCount = cards.filter(card => card.classList.contains('active')).length;

                  for (let i = visibleCount; i < visibleCount + itemsPerPage && i < cards.length; i++) {
                      cards[i].classList.add('active');
                      cards[i].classList.remove('hidden');
                  }
                  if (visibleCount + itemsPerPage >= cards.length) {
                      loadMoreBtn.style.display = 'none';
                  }
              });
          });
      });
  });


  // --------------Skin logic Script-----------------
  const skinLogicContent = document.querySelector('[js-skin-logic-content]');
  if(skinLogicContent) {
      if (window.innerWidth <= 767) {
      new Swiper('[js-skin-logic]', {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
      
          navigation: { 
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          },
          pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
          return '<span class="' + className + '">°' + (index + 1) + '</span>';
          },
          },  
      });

      const contentElements = document.querySelectorAll('[js-skin-content]');
      const contentPagination = document.querySelector('[js-skin-logic-pagination]');
      let maxHeight = 0;
      contentElements.forEach((element) => {
          const elementHeight = element.scrollHeight;
          if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
          }
      });
      contentPagination.style.bottom = maxHeight + 20 + 'px';
      }
  }
  // skincare-product-slider
  document.addEventListener("DOMContentLoaded", function () {
      if (window.innerWidth > 720) {
          const swiper = new Swiper('.js-skincare-product-slider', {
              slidesPerView: 2,
              spaceBetween: 20,
              watchSlidesProgress: true,
              draggable: true,
              autoHeight: false,
              watchOverflow: true,
              threshold: 10,
              mousewheel: {
                  forceToAxis: true
              },
          });
      }
  });

    // <!-- Initialize Swiper -->
    new Swiper("[js-bd-product-set]", {
      slidesPerView: "auto",
      spaceBetween: 20
    });

    // Tab functionality for Skin Care Section
    document.addEventListener("DOMContentLoaded", function () {
        const tabs = document.querySelectorAll('[js-tab-model]');
        const productSections = document.querySelectorAll('[js-skin-care-product]');
        let swiperInstances = [];

        function initSwipers(section) {
            const sliders = section.querySelectorAll('[data-js-product-image-slider]');
            sliders.forEach((slider) => {
                const swiper = new Swiper(slider, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                swiperInstances.push(swiper);
            });

            const containerSwiper = new Swiper(section, {
                slidesPerView: 2,
                spaceBetween: 20,
                loop: false, 
                watchSlidesProgress: true,
                draggable: true,
                autoHeight: false,
                watchOverflow: true,
                threshold: 10,
                mousewheel: {
                    forceToAxis: true
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.126,
                        spaceBetween: 10,
                    },
                    767: {
                        slidesPerView: 1.3,
                        spaceBetween: 15,
                    },
                    991: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    1280: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                },
            });
            swiperInstances.push(containerSwiper);
        }

        function destroySwipers() {
            swiperInstances.forEach(instance => {
                if (instance && typeof instance.destroy === 'function') {
                    instance.destroy(true, true);
                }
            });
            swiperInstances = [];
        }

        function activateTab(index) {
            tabs.forEach(t => t.classList.remove('active'));
            productSections.forEach(section => {
                section.classList.add('hidden');
                section.classList.remove('active');
            });

            const tabToActivate = document.querySelector(`[js-tab-model][data-index="${index}"]`);
            const sectionToActivate = document.querySelector(`[js-skin-care-product][data-index="${index}"]`);

            if (tabToActivate) tabToActivate.classList.add('active');
            if (sectionToActivate) {
                sectionToActivate.classList.remove('hidden');
                sectionToActivate.classList.add('active');

                destroySwipers();
                initSwipers(sectionToActivate);
            }
        }

        if (tabs.length > 0 && productSections.length > 0) {
            activateTab(0);
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', function () {
                const index = this.getAttribute('data-index');
                activateTab(index);
            });
        });
    });
    window.addEventListener("load", function() {
        document.querySelectorAll("[delayed-section]").forEach(section => {
            section.style.display = "block";
        });
        document.body.classList.remove("loading-pages");
    });
})();
